import { BlastEvent, SimulationConfig } from '../../../types';
import { drawBlastShape } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ExplosionAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const easedProgress = 1 - Math.pow(1 - progress, 3);
  drawBlastShape(ctx, e, e.maxRadius * easedProgress);
  ctx.lineWidth = 20 * (1 - progress);
  ctx.stroke();
};

registerBlastAnimation('EXPLOSION', ExplosionAnimation);
